export enum InsuranceReviewEvents {
  ITEM_FLAGGED_EVENT = 'ITEM FLAGGED',
  ITEM_UNFLAGGED_EVENT = 'ITEM UNFLAGGED',
  ITEM_UPDATED_EVENT = 'ITEM UPDATED',
}

export const INSURANCE_REVIEW_EVENT_TYPE = 'Insurance Review';